import { marketConfig } from '../../config/market-configs'
import { MarketMetadata } from '../../config/types'

export const useSiteMetadata = (): MarketMetadata => marketConfig.meta
